import styled from 'styled-components';

export const CdLabelCell = styled.div<{ gridTemplateColumns?: string }>`
  display: grid;
  width: 100%;
  gap: ${(props) => props.theme.spacing.spacing4};
  grid-template-columns: ${(props) => (props.gridTemplateColumns ? props.gridTemplateColumns : '1fr min-content 1fr')};
  align-items: center;
`;
